import _ from "lodash";
import { TromanError } from "@/common/TromanError";
import { ErrorInfo } from "./ErrorInfo";
import { AuthError } from "@/common/auth/AuthError";
import { RequestError } from "@/common/RequestError";

export function parseError(err: any) {

    if (err instanceof TromanError) {
        return new ErrorInfo(err.code, [err.message]);
    }

    if (err instanceof AuthError) {
        return new ErrorInfo(err.code, [err.message]);
    }

    if (err instanceof RequestError) {
        if (err.result.errors) {
            // Validation errors take the form errors: { "PropertyName": [ "message", ...], ... }
            let messages = _.flatMap(err.result.errors, x => _.map(x)) as string[];
            return new ErrorInfo("eparse_data_modelstate", messages);
        }

        if (err.result.detail) {
            return new ErrorInfo("eparse_data_message", [err.result.detail]);
        }

        return new ErrorInfo(err.code, [err.message]);
    }

    if (err instanceof Error) {
        console.log("Runtime error: " + err, err);
        return new ErrorInfo("eparse_runtime_error", ["Internt fel 2"]);
    }

    if (typeof err === 'string') {
        return new ErrorInfo("eparse_string", [err]);
    }

    console.log("Unknown error: " + err, err);
    return new ErrorInfo("eparse_unknown", ['Internt fel 3']);
}